import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config: any) => {
    const token = localStorage.getItem('authToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error: any) => {
    return Promise.reject(error);
});

api.interceptors.response.use((response: any) => {
    let renewedToken = response.headers['x-renewed-token'];

    if (renewedToken) {
        localStorage.setItem('authToken', renewedToken);
    }else {

        renewedToken = response.headers['X-Renewed-Token'];

        if (renewedToken) {
            localStorage.setItem('authToken', renewedToken);
        }
    }

    return response;
}, (error: any) => {
    if (error.response && error.response.status === 401) {
        localStorage.removeItem('authToken');
        if(!window.location.href.includes('login') &&
            !window.location.href.includes('/') &&
            !window.location.href.includes('/invite/') &&
            !window.location.href.includes('/notConfirmed/') &&
            !window.location.href.includes('/notApproved') &&
            !window.location.href.includes('/confirm/') &&
            !window.location.href.includes('/unauthorized') &&
            !window.location.href.includes('/privacy-policy') &&
            !window.location.href.includes('/recover-password') &&
            !window.location.href.includes('/recover') &&
            !window.location.href.includes('/reset-password') &&
            !window.location.href.includes('/terms-and-conditions')
        ) {
            window.location.href = '/login';
        }
    }
    return Promise.reject(error);
});

export default api;
